// APPLICATIONS
import {
  GET_APPLICATIONS,
  GET_APPLICATIONS_SUCCESS,
  APPLICATIONS_ERROR,
} from '../constants/action-types/applications';

export const getApplications = () => ({
  type: GET_APPLICATIONS,
});

export const getApplicationsSuccess = data => ({
  type: GET_APPLICATIONS_SUCCESS,
  data,
});

export const applicationsError = () => ({
  type: APPLICATIONS_ERROR,
});
